// frontend-react/src/components/IADraftList.js - NUEVO ARCHIVO
import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Chip,
  Alert,
  CircularProgress,
} from "@mui/material";
import { Edit, Visibility, AutoAwesome } from "@mui/icons-material";
import { blogService } from "../api/services";
import { safeMap, safeArray } from "../utils/validation";

const IADraftList = ({ onEditPost }) => {
  const [drafts, setDrafts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchIADrafts();
  }, []);

  const fetchIADrafts = async () => {
    try {
      const response = await blogService.getAllPosts();
      // Filtrar solo borradores generados por IA
      const iaDrafts = safeArray(response.data).filter(
        (post) => post.is_auto_generated && post.status === "draft"
      );
      setDrafts(iaDrafts);
    } catch (err) {
      setError("Error al cargar borradores de IA");
      console.error("Error fetching IA drafts:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (post) => {
    if (onEditPost) {
      onEditPost(post);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Card>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <AutoAwesome sx={{ mr: 1 }} />
          <Typography variant="h6">Borradores Generados por IA</Typography>
        </Box>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError("")}>
            {error}
          </Alert>
        )}

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Título</TableCell>
                <TableCell>Categorías</TableCell>
                <TableCell>Fecha de Creación</TableCell>
                <TableCell>Estado</TableCell>
                <TableCell>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {safeMap(drafts, (post) => (
                <TableRow key={post.id}>
                  <TableCell>
                    <Typography variant="body2" fontWeight="bold">
                      {post.title}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
                      {safeMap(post.categories, (category) => (
                        <Chip
                          key={category.id}
                          label={category.name}
                          size="small"
                          sx={{
                            backgroundColor: category.color,
                            color: "white",
                            fontSize: "0.7rem",
                          }}
                        />
                      ))}
                    </Box>
                  </TableCell>
                  <TableCell>
                    {new Date(post.created_at).toLocaleDateString()}
                  </TableCell>
                  <TableCell>
                    <Chip label={post.status} color="warning" size="small" />
                  </TableCell>
                  <TableCell>
                    <Button
                      startIcon={<Edit />}
                      onClick={() => handleEdit(post)}
                      size="small"
                      variant="outlined"
                    >
                      Editar
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {drafts.length === 0 && !loading && (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <Typography variant="body1" color="text.secondary">
              No hay borradores generados por IA
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default IADraftList;
